import {
  useReducer, useCallback, useMemo, useRef,
} from 'react';
import isEqual from 'lodash.isequal';

import html2canvas from 'html2canvas';

import {
  getBatch,
  getRefDashboardItem,
  getRefDashboardViewLogs,
  // kpi
  getRefKpiItemList,
  getRefKpiLayout,
  getRefKpiItem,
  getRefDrilldownItem,
  // getRefPublicKpiList,
  // getRefPublicDashboard,
  // getRefPublicLayout,
  getRefDashResumes,
  getRefKpisResumes,
  getRefDashResume,
  getRefKpisFromResume,
  // layout
  layoutAll2Firestore,
  layoutInsert2Firestore,
  layoutUpdate2Firestore,
  // Comments  - Mural
  getRefCommentsList,
  getRefComment,
  // template
  getRefTemplateList,
  getRefTemplateDoc,
  getRefTemplateLayout,
  getRefTemplateKpis,
  getRefSharedItem,
  getTransaction,
  getListener,
} from '../utils/firestore';
import genPublicKpisFunc from '../utils/functions/genPublicKpis';

import differenceSet from '../utils/functions/differenceSet';
import getRequestMeta, { getPublicRequestMeta } from '../utils/functions/generateMeta';
import { ip, ipAdmin } from '../utils/functions/urls';
import firebase from '../utils/firebase';
import firestoreErrors from '../utils/firestoreErrors';
import { error as errorLabels } from '../label';
import notificationTriggers from './notifications';
import createLog from './createLog';
import uuidv4 from '../juristec-ui/utils/functions/randomUUID';

const defaultLayout = {
  lg: [],
  md: [],
  sm: [],
  xs: [],
  xxs: [],
};

const CHANGES = {
  layout: 'layout',
  kpis: 'kpis',
  dashboard: 'dashboard',
  filters: 'filters',
};

const commentsLimitPerLoad = 30;

// Máximo de views por dashboard para manter o documento sob 1MB
const MAX_VIEWS_PER_DASHBOARD = 100;

const initialState = {
  isLoading: false,
  collection: 'kpis', // qual snap q tá aberto.
  snapshots: [], // fica dentro do dashboard
  kpiItemList: [],
  dashboardDoc: null,
  kpisLayout: defaultLayout,
  //
  comments: [],
  commentsCursor: null,
  commentsLoading: false,
  commentsLoadingMore: false,
  commentsLoadingError: false,

  resumes: null,
  resumeKpis: {},
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'loadCards':
      return {
        ...state,
        kpisLayout: action.kpisLayout,
        kpiItemList: action.kpis,
        dashboardDoc: action.dashboardDoc,
        collection: action.collection,
        isLoading: false,
      };

    case 'loadLiveCards':
      return {
        ...state,
        collection: 'kpis',
        // isLoading: false,
      };

    case 'setLiveDashAll':
      return {
        ...state,
        kpisLayout: action.kpisLayout || defaultLayout,
        kpiItemList: action.kpis,
        dashboardDoc: action.dashboardDoc,
        isLoading: false,
      };

    case 'setLiveDashAndLayout':
    case 'loadLayoutAndDash':
      return {
        ...state,
        kpisLayout: action.kpisLayout || defaultLayout,
        dashboardDoc: action.dashboardDoc,
        isLoading: false,
      };

    case 'setLiveDash':
    case 'setDashboard':
      return {
        ...state,
        isLoading: false,
        dashboardDoc: action.dashboardDoc,
      };

    /// create KPI Coment
    case 'createKpiComment':
      return {
        ...state,
        kpiItemList: [state.kpiItemLIst, action.comment],
      };

    case 'removeCards':
      return {
        ...state,
        kpisLayout: action.updatedData.layout,
        dashboardDoc: {
          ...state.dashboardDoc,
          ...action.updatedData.dashDoc,
        },
        kpiItemList: action.updatedData.kpis,
        isLoading: false,
      };

    case 'cloneCard':
      return {
        ...state,
        isLoading: false,
        kpisLayout: action.kpisLayout,
        kpiItemList: [...state.kpiItemList, action.clonedCard],
      };

    case 'setLayout':
      return { ...state, kpisLayout: action.kpisLayout, isLoading: false };

    case 'loadComments':
      return {
        ...state,
        comments: action.comments,
        commentsCursor: action.cursor,
        commentsLoading: false,
        commentsLoadingError: false,
      };

    case 'loadMoreComments':
      return {
        ...state,
        comments: [...action.comments, ...state.comments],
        commentsCursor: action.cursor,
        commentsLoadingMore: false,
      };

    case 'addComment':
      return {
        ...state,
        comments: [...state.comments, action.comment],
        // commentsLoading: false,
      };

    case 'editComment':
      return {
        ...state,
        comments: state.comments.map((c) => {
          if (c.id === action.commentId) {
            return {
              ...c,
              ...action.editInfos,
            };
          }
          return c;
        }),
      };

    case 'archiveComment':
      return {
        ...state,
        comments: state.comments.filter((c) => c.id !== action.commentId),
      };

    case 'commentsLoadingError':
      return { ...state, commentsLoadingError: action.error, commentsLoading: false };

    case 'setDescription':
      return {
        ...state,
        dashboardDoc: { ...state.dashboardDoc, description: action.description },
      };

    case 'setLoadMoreLoading':
      return { ...state, commentsLoadingMore: action.l };

    case 'setCommentsLoading':
      return { ...state, commentsLoading: action.l };
    case 'setLoading':
      return { ...state, isLoading: action.isLoading };

    case 'setCardStyles':
      return {
        ...state,
        isLoading: false,
        dashboardDoc: { ...state.dashboardDoc, cardStyles: action.cardStyles },
      };

    case 'setGlobalFilterSelectors':
      return {
        ...state,
        isLoading: false,
        dashboardDoc: {
          ...state.dashboardDoc,
          globalFilters: action.globalFilters,
          globalLimits: action.globalLimits,
        },
      };

    case 'attDashDocPublic':
      return {
        ...state,
        dashboardDoc: {
          ...state.dashboardDoc,
          publicUrl: action.publicUrl,
          publicTimestamp: action.publicTimestamp,
          passwordProtected: action.passwordProtected,
        },
        isLoading: false,
      };

    case 'dashResumes':
      return {
        ...state,
        resumes: action.resumes,
        isLoading: false,
      };

    case 'kpisResumes': {
      const tsResume = state.resumes.get(action.key);
      if (!tsResume) return { ...state, isLoading: false };
      tsResume.resumes = action.resumes;
      return {
        ...state,
        resumes: new Map(state.resumes.set(action.key, tsResume)),
        isLoading: false,
      };
    }

    case 'genDashResumes': {
      const tsResume = {
        id: action.key,
        createdAt: new Date(action.key),
        response: '',
        status: 'doing',
        resumes: null,
      };
      return {
        ...state,
        resumes: new Map(state.resumes.set(action.key, tsResume)),
        isLoading: false,
      };
    }

    case 'updateDashResume': {
      let tsResume = state.resumes.get(action.key);
      if (!tsResume) return { ...state, isLoading: false };
      tsResume = { ...tsResume, ...action.data };
      return {
        ...state,
        resumes: new Map(state.resumes.set(action.key, tsResume)),
        isLoading: false,
      };
    }

    case 'updateDashResumeKpi': {
      const tsResume = state.resumes.get(action.key);
      if (!tsResume) return { ...state, isLoading: false };
      if (tsResume.resumes instanceof Map) {
        tsResume.resumes = tsResume.resumes.set(...action.data);
      } else {
        tsResume.resumes = new Map([action.data]);
      }
      return {
        ...state,
        resumes: new Map(state.resumes.set(action.key, tsResume)),
        isLoading: false,
      };
    }

    case 'kpisFromResume':
      return {
        ...state,
        resumeKpis: { [action.key]: action.kpis },
        isLoading: false,
      };

    default:
      return state;
  }
};

const getToken = async (u) => u.getIdToken();
// const parseKpi = (kpi) => {
//   const parsedKpi = {};
//   Object.keys(kpi).forEach((propertie) => {
//     try {
//       parsedKpi[propertie] = [
//         'name', 'comment', 'updatedBy', 'type', 'databaseFilename', 'status', 'createdAt',
//         'updatedAt', 'databaseFileId', 'database', 'link', 'linkType', 'question', 'fileOwner',
//       ].includes(propertie) ? kpi[propertie] : JSON.parse(kpi[propertie]);
//     } catch (_) {
//       parsedKpi[propertie] = kpi[propertie];
//     }
//   });
//   return parsedKpi;
// };

const isString = (s) => typeof s === 'string' || s instanceof String;
const isFile = (f) => f instanceof Blob || f instanceof File;

// getRefKpiLayout, getRefKpiItemList
function useGridKPI(ownerId, currentDashId, currentUser, userDoc) {
  const dashLoaded = useRef(false);
  const [state, dispatch] = useReducer(reducer, initialState);
  const setLoading = (l = true) => dispatch({ type: 'setLoading', isLoading: l });
  // const setCommentsLoading = (l = true) => dispatch({ type: 'setCommentsLoading', l });

  const setViewLog = useCallback(async (dashRef) => {
    let merge = false;
    let docId;
    const dateNow = new Date().toISOString().split('T');
    const todaySnaps = await getRefDashboardViewLogs(dashRef).where('date', '==', dateNow[0]).limit(1).get();
    if (!todaySnaps.empty) {
      docId = todaySnaps.docs[0].id;
      merge = true;
    } else {
      const oldSnaps = await getRefDashboardViewLogs(dashRef).orderBy('date', 'asc').limit(31).get();
      if (!oldSnaps.empty && oldSnaps.size > 30) docId = oldSnaps.docs[0].id;
    }

    getRefDashboardViewLogs(dashRef).doc(docId).set({
      date: dateNow[0],
      at: firebase.arrayUnion(dateNow[1].replace('Z', '+00:00')),
    }, { merge });
  }, []);

  const tryGetRef = useCallback(async (ids, nextIdx = 0) => {
    if (nextIdx >= ids.length) return [null, null];
    const dashRef = getRefSharedItem(ids[nextIdx], `${ownerId}_${currentDashId}`);
    const dashSnapshot = await dashRef.get();
    if (!dashSnapshot.exists()) {
      const res = await tryGetRef(ids, nextIdx + 1);
      return res;
    }
    const dashData = dashSnapshot.data() || {};
    return [dashRef, dashData];
  }, [ownerId, currentUser, currentDashId]);

  const setViewAt = useCallback(async () => {
    try {
      const isShared = ownerId !== currentUser.uid;
      let dashRef = null;
      let dashData = null;
      if (isShared) {
        [dashRef, dashData] = await tryGetRef([currentUser.uid, ...(userDoc.groups ?? [])]);
      } else {
        dashRef = getRefDashboardItem(ownerId, currentDashId);
        const dashSnapshot = await dashRef.get();
        if (dashSnapshot.exists()) dashData = dashSnapshot.data() || {};
      }

      if (dashRef === null || dashData === null) {
        return {
          error: true,
          msg: 'Dashboard removido ou não encontrado!',
          raw: '',
        };
      }
      // Recuperar documento atual para gerenciar views
      if ((dashData.status && dashData.status !== 'active') || dashData.isDeleted) {
        return {
          error: true,
          msg: 'Dashboard removido ou não encontrado!',
          raw: '',
        };
      }
      const currentViews = dashData.views || [];
      // Preparar novo registro de view
      const formatTimestamp = (timestamp) => {
        if (!timestamp) return null;

        const date = typeof timestamp?.toDate === 'function'
          ? timestamp.toDate()
          : new Date(timestamp);

        // eslint-disable-next-line no-restricted-globals
        if (isNaN(date)) return null;

        return date.toISOString().replace('T', ' ').slice(0, 19);
      };
      const now = formatTimestamp(new Date());
      const dashUpdatedAt = formatTimestamp(dashData.updatedAt)
        || formatTimestamp(dashData.lastUpdateUser)
        || formatTimestamp(dashData.createdAt);

      const newView = {
        viewAt: now,
        updatedAt: dashUpdatedAt,
        viewBy: currentUser.uid,
      };

      // Adicionar novo view e manter apenas os últimos MAX_VIEWS_PER_DASHBOARD
      const updatedViews = [newView, ...currentViews].slice(0, MAX_VIEWS_PER_DASHBOARD);

      // Salvar documento com views atualizadas
      dashRef.set({
        viewAt: firebase.serverTimestamp(),
        views: updatedViews,
      }, { merge: true });
      await setViewLog(dashRef);
      return { error: false, msg: '' };
    } catch (er) {
      console.log(er);
      return { error: true, msg: firestoreErrors(er.code), raw: `Erro do sistema: ${er.toString()}` };
    }
  }, [ownerId, currentUser, currentDashId]);

  const setLastUpdateUserOnShared = useCallback(async (dashdoc, updateWhere) => {
    try {
      if (dashdoc.sharedWith) {
        const batch = getBatch();
        Object.keys(dashdoc.sharedWith).forEach((id) => {
          // const { sharedAt, value } = dashdoc.sharedWith[id];
          // console.log('lastUpdate no shared: ', id, `${currentUser.uid}_${currentDashId}`);
          const sharedRef = getRefSharedItem(id, `${currentUser.uid}_${currentDashId}`);
          batch.set(sharedRef, {
            lastUpdateUser: firebase.serverTimestamp(),
            lastChangesAffect: updateWhere,
          }, { merge: true });
        });
        return batch.commit();
      }
      return null;
    } catch (er) {
      console.log(er);
      return null;
    }
  }, [currentDashId, currentUser]);

  const getPlotlyLink = useCallback(async (plotlyId) => {
    try {
      const token = await getToken(currentUser);
      const opt = {
        ...await getRequestMeta(token, 'POST', 'JSON'),
      };
      const resFetch = await fetch(`${ip}/kpis/custom/${plotlyId}`, opt);
      const json = await resFetch.json();

      if (resFetch.status !== 200) {
        return {
          error: true,
          msg: errorLabels.useGridKpi.getPlotlyLink,
          raw: json.error,
        };
      }

      return { error: false, link: `${ip}/kpis/custom/${plotlyId}&${json.info}` };
    } catch (er) {
      console.log(er);
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.getPlotlyLink,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, [currentUser]);

  const parseKpiData = useCallback(async (kpi, snap, ddRef = null) => {
    const parsedKpi = {};
    Object.keys(kpi).forEach((propertie) => {
      try {
        parsedKpi[propertie] = [
          'name', 'comment', 'updatedBy', 'type', 'databaseFilename', 'status', 'createdAt',
          'updatedAt', 'databaseFileId', 'database', 'link', 'linkType', 'question', 'fileOwner', 'showOnExpand',
        ].includes(propertie) ? kpi[propertie] : JSON.parse(kpi[propertie]);
      } catch (_) {
        parsedKpi[propertie] = kpi[propertie];
      }
    });
    if (parsedKpi.type === 'Iframe' && parsedKpi.linkType === 'plotly') {
      parsedKpi.linkId = parsedKpi.link;
      const plotlyRes = await getPlotlyLink(parsedKpi.link);
      if (plotlyRes.error) parsedKpi.link = null;
      else parsedKpi.link = plotlyRes.link;
    }
    if (ddRef && parsedKpi.style?.DrilldownStyle && parsedKpi.style?.DrilldownStyle !== 'auto') {
      const ddStyles = await ddRef.get();
      if (ddStyles.exists()) parsedKpi.style.DDStyles = { ...ddStyles.data() };
    }
    const allowedTypes = [
      'Bar',
      'Line',
      'Pie',
      'Map',
      'Funnel',
      'RadialBar',
      'BoxPlot',
    ];

    if (
      parsedKpi?.meta && (
        (snap !== 'kpis' && parsedKpi?.meta?.drilldown)
        || !allowedTypes.includes(parsedKpi.type)
      )
    ) parsedKpi.meta.drilldown = [];
    return parsedKpi;
  }, []);

  const getKpi = useCallback(async (userId, dashId, kpiId, snap) => {
    const kpiRaw = await getRefKpiItem(userId, dashId, kpiId, snap || 'kpis').get();
    const kpiLoaded = {
      ...await parseKpiData(kpiRaw.data(), snap || 'kpis', getRefDrilldownItem(userId, dashId, kpiRaw.id)),
      id: kpiRaw.id,
    };
    return kpiLoaded;
  }, []);

  const getKpisLayout = useCallback(async (userId, dashId, snap) => {
    const lytRaw = await getRefKpiLayout(userId, dashId, snap || 'kpis').get();
    return lytRaw.data();
  }, []);

  const getKpisList = useCallback(async (userId, dashId, snap) => {
    const kpisListRaw = await getRefKpiItemList(userId, dashId, snap || 'kpis').get();
    const kpisListLoaded = await Promise.all(
      kpisListRaw.docs.map(async (k) => ({
        ...await parseKpiData(k.data(), snap || 'kpis', getRefDrilldownItem(userId, dashId, k.id)),
        id: k.id,
      })),
    );
    return kpisListLoaded;
  }, []);

  const getDashboard = useCallback(async (userId, dashId) => {
    const dashRaw = await getRefDashboardItem(userId, dashId).get();
    return { ...dashRaw.data(), id: dashRaw.id };
  }, []);

  const getAllInfosLive = useCallback(async (userId, dashboardId) => {
    try {
      const viewAtRes = await setViewAt();
      if (viewAtRes.error) return viewAtRes;
      const listener = getListener();
      const detachDash = listener(getRefDashboardItem(userId, dashboardId), async (snapshot) => {
        if (snapshot.exists() && !snapshot.metadata.hasPendingWrites) {
          const datum = { ...snapshot.data(), id: snapshot.id };
          if (datum.isDeleted) {
            // console.log('UPDATE DELETED');
            dispatch({
              type: 'setLiveDashAll',
              dashboardDoc: { id: datum.id, isDeleted: true },
              kpis: [],
              kpisLayout: defaultLayout,
            });
          } else if (
            !dashLoaded.current || [CHANGES.filters, CHANGES.kpis].includes(datum.lastChangesAffect)
          ) {
            // console.log('UPDATED ALL');
            const [kpis, kpisLayout] = await Promise.all([
              getKpisList(userId, dashboardId, 'kpis'),
              getKpisLayout(userId, dashboardId, 'kpis'),
            ]);
            dispatch({
              type: 'setLiveDashAll',
              dashboardDoc: datum,
              kpis,
              kpisLayout,
            });
          } else if (datum.lastChangesAffect === CHANGES.layout) {
            // console.log('UPDATED LAYOUT');
            const kpisLayout = await getKpisLayout(userId, dashboardId, 'kpis');
            dispatch({
              type: 'setLiveDashAndLayout',
              dashboardDoc: datum,
              kpisLayout,
            });
          } else {
            // console.log('UPDATED DASHBOARD DOC');
            dispatch({
              type: 'setLiveDash',
              dashboardDoc: datum,
            });
          }
          dashLoaded.current = true;
        }
      });
      return {
        error: false, msg: '', raw: '', detachDash,
      };
    } catch (er) {
      console.log(er);
      return { error: true, msg: firestoreErrors(er.code) || errorLabels.useGridKpi.getAllInfos, raw: `Erro do sistema: ${er.toString()}` };
    }
  }, [setViewAt, getKpisList, getKpisLayout]);

  const getAllInfos = useCallback(async (userId, dashboardId, collection) => {
    try {
      const [kpis, kpisLayout, dashboardDoc] = await Promise.all([
        getKpisList(userId, dashboardId, collection),
        getKpisLayout(userId, dashboardId, collection),
        getDashboard(userId, dashboardId)]);
      if (dashboardDoc && dashboardDoc.status && !dashboardDoc.isDeleted) {
        await setViewAt();
      }
      return {
        error: false, msg: '', kpis, kpisLayout, dashboardDoc, raw: '',
      };
    } catch (er) {
      console.log(er);
      return { error: true, msg: firestoreErrors(er.code) || errorLabels.getAllInfos, raw: `Erro do sistema: ${er.toString()}` };
    }
  }, [getDashboard, setViewAt, getKpisList, getKpisLayout]);

  /// ///////////// SAVELAYOUT ////////////////////
  const saveLayout = useCallback(async (userId, dashId, toSaveLayout, snap) => {
    try {
      const batch = getBatch();
      const lytRef = getRefKpiLayout(userId, dashId, snap || 'kpis');
      batch.set(lytRef, layoutAll2Firestore(toSaveLayout), { merge: true });
      batch.set(getRefDashboardItem(userId, dashId), {
        lastUpdateUser: firebase.serverTimestamp(),
        lastChangesAffect: CHANGES.layout,
      }, { merge: true });
      await batch.commit();
      return { error: false, msg: '' };
    } catch (er) {
      return { error: true, msg: firestoreErrors(er.code) || errorLabels.saveLayout, raw: `Erro do sistema: ${er.toString()}` };
    }
  }, []);

  // Internal use
  const changeFilePermission = useCallback(async (fileId, selected) => {
    try {
      const token = await getToken(currentUser);
      const opt = {
        ...await getRequestMeta(token, 'PUT', 'JSON'),
        body: JSON.stringify({
          users: [
            ...selected.map((uid) => ({
              uid,
              read: true,
            })),
          ],
        }),
      };
      const resFetch = await fetch(`${ip}/db/file/permissions/${fileId}`, opt);
      const json = await resFetch.json();

      if (resFetch.status !== 200) {
        return {
          error: true,
          msg: errorLabels.useGridKpi.createCard,
          raw: json.error,
        };
      }

      return { error: false, msg: '' };
    } catch (er) {
      console.log(er);
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.createCard,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, [currentUser]);

  const checkLabelField = (LabelData, field) => ([
    'label', 'Iframe',
  ].includes(LabelData.type) ? firebase.deleteField() : LabelData[field]);

  /// //////////// SAVE INSIGHT CARD //////////
  const saveInsightCard = useCallback(async (
    userId, dashId, companyId, kpiLayout, labelKey, LabelData, image,
  ) => {
    try {
      const refDashboard = getRefDashboardItem(userId, dashId);
      await getTransaction((transaction) => transaction.get(refDashboard)
        .then(async (dash) => {
          if (!dash.exists()) {
            throw new Error('dashboad does not exist!');
          }
          const refDashboardLayout = getRefKpiLayout(userId, dashId, 'kpis');
          const LabelObject = {
            ...LabelData,
            meta: checkLabelField(LabelData, 'meta'),
            database: checkLabelField(LabelData, 'database'),
            fileOwner: checkLabelField(LabelData, 'fileOwner'),
            updatedAt: firebase.serverTimestamp(),
          };

          let imgUrl = isString(image) ? image : '';
          if (isFile(image)) {
            imgUrl = await firebase.uploadImage(`companies/${companyId}/images/${userId}/`, image);
          }

          LabelObject.style.image = imgUrl;
          if (labelKey !== 'new') {
            const labelRef = getRefKpiItem(userId, dashId, labelKey);
            transaction.update(labelRef, LabelObject);

            transaction = createLog('insight', 'edit', {
              userDoc, labelId: labelRef.id, dashId,
            }, transaction);
          } else {
            // const dashboardNewDocument = refDashboardItemList.doc();
            const newKpiDoc = getRefKpiItemList(userId, dashId).doc();
            transaction.set(newKpiDoc, {
              ...LabelObject,
              createdAt: firebase.serverTimestamp(),
            }, { merge: true });

            transaction = createLog('insight', 'add', {
              userDoc, labelId: newKpiDoc.id, dashId,
            }, transaction);

            // UPDATE dashboardlayout
            const ndoc = {
              i: newKpiDoc.id,
              w: 12,
              h: 10,
              x: 0,
              y: 1000,
            };
            const newStateDashLayout2Firestore = layoutInsert2Firestore(kpiLayout, ndoc);
            transaction.set(refDashboardLayout, newStateDashLayout2Firestore, { merge: true });
          }

          // UPDATE DASHBOARD_DOC
          const oldDatabases = dash.get('databases') || [];
          const databases = LabelData.database && !oldDatabases.includes(LabelData.database)
            ? [...oldDatabases, LabelData.database] : oldDatabases;
          transaction.update(refDashboard,
            {
              databases,
              lastUpdateUser: firebase.serverTimestamp(),
              lastChangesAffect: CHANGES.kpis,
            });

          // UPDATING FILE PERMISSIONS FOR ALREADY SHARED USERS
          // AND LASTUPDATUSER
          const alreadyShared = dash.get('sharedWith') || {};
          if (Object.keys(alreadyShared).length) {
            await setLastUpdateUserOnShared(dash.data(), CHANGES.kpis);
            // transaction = notificationTriggers('create_update', {
            //   KpiObject, dashData: dash.data(), userDoc, kpiKey, kpiId: ndoc.i, dashId,
            // }, transaction);
          }
          if (!oldDatabases.includes(LabelData.database)
          && Object.keys(alreadyShared).length > 0
          && LabelData.fileOwner === userId) {
            const fileRes = await changeFilePermission(
              LabelData.database, Object.keys(alreadyShared),
            );
            if (fileRes.error) return fileRes.error;
          }
        }));
      return { error: false, msg: '' };
    } catch (er) {
      console.log(er);
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.createInsight,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, []);

  /// SAVE KPI COMMENT (CREATE AND UPDATE) ///
  const saveKpiComment = useCallback(
    async (kpiKey, comment) => {
      try {
        const batch = getBatch();
        const refKpiToUpdate = getRefKpiItem(ownerId, currentDashId, kpiKey);
        batch.set(refKpiToUpdate, { comment }, { merge: true });
        batch.set(getRefDashboardItem(ownerId, currentDashId), {
          lastUpdateUser: firebase.serverTimestamp(),
          lastChangesAffect: CHANGES.kpis,
        }, { merge: true });
        await batch.commit();
        return { error: false, msg: '' };
      } catch (error) {
        console.log(error);
        return {
          error: true,
          msg: firestoreErrors(error.code) || errorLabels.useGridKpi.createKpiComment,
          raw: `Erro do sistema: ${error.toString()}`,
        };
      }
    }, [],
  );
  const updateKpiShowOnExpand = useCallback(
    async (kpiKey, showOnExpand) => {
      try {
        const refKpiToUpdate = getRefKpiItem(ownerId, currentDashId, kpiKey);
        await refKpiToUpdate.set({ showOnExpand }, { merge: true });
        return { error: false, msg: '' };
      } catch (error) {
        console.log(error);
        return {
          error: true,
          msg: firestoreErrors(error.code) || errorLabels.useGridKpi.updateKpiShowOnExpand,
          raw: `Erro do sistema: ${error.toString()}`,
        };
      }
    }, [],
  );

  /// SAVE KPI VALUE FILTERS (CREATE AND UPDATE) ///
  const saveKpiValueFilters = useCallback(
    async (kpiKey, metaGen, pivotTable) => {
      try {
        const batch = getBatch();
        const refKpiToUpdate = getRefKpiItem(ownerId, currentDashId, kpiKey);
        batch.set(refKpiToUpdate, {
          updatedAt: firebase.serverTimestamp(),
          meta: JSON.stringify(metaGen),
          data: JSON.stringify(pivotTable),
        }, { merge: true });
        batch.set(getRefDashboardItem(ownerId, currentDashId), {
          lastUpdateUser: firebase.serverTimestamp(),
          lastChangesAffect: CHANGES.kpis,
        }, { merge: true });
        await batch.commit();
        return { error: false, msg: '' };
      } catch (error) {
        console.log(error);
        return {
          error: true,
          msg: firestoreErrors(error.code) || errorLabels.useGridKpi.createKpiValueFilters,
          raw: `Erro do sistema: ${error.toString()}`,
        };
      }
    }, [],
  );

  /// //////////////// SAVE CARD (CREATE AND UPDATE) ///////////////////
  const saveKpiCard = useCallback(async (
    userId,
    dashId,
    kpiName,
    kpiKey,
    cardType,
    dashLayout,
    metaGen,
    metaGridInfo,
    pivotTable,
    styleConfig,
    ddStyleConfig,
  ) => {
    try {
      const refDashboardLayout = getRefKpiLayout(userId, dashId, 'kpis');

      const KpiObject = {
        name: kpiName,
        status: 'active',
        updatedAt: firebase.serverTimestamp(),
        type: cardType,
        meta: JSON.stringify(metaGen),
        // data: JSON.stringify(pivotTable),
        style: JSON.stringify(styleConfig),
        database: metaGen.database,
        lastAttemptAt: firebase.serverTimestamp(),
      };
      if (cardType === 'ReportGrid' && metaGen.reportGrid?.configuration?.saveConfigurationOnly) {
        // Substitui também o dataset anterior sem serializá-lo nem incluí-lo nos logs.
        KpiObject.data = null;
      } else if (cardType !== 'SubsetTable') {
        KpiObject.data = JSON.stringify(pivotTable);
      }

      const refDashboard = getRefDashboardItem(userId, dashId);

      await getTransaction((transaction) => transaction.get(refDashboard)
        .then(async (dash) => {
          if (!dash.exists()) {
            throw new Error('dashboad does not exist!');
          }
          let ndoc = {};
          // UPDATE INSERT
          if (kpiKey !== 'new') {
            const toUpdateKpie = getRefKpiItem(userId, dashId, kpiKey);
            // const dashboardNewDocument = refDashboardItemList.doc(kpiKey);
            transaction.update(toUpdateKpie, KpiObject);
            if (ddStyleConfig) {
              const ddRef = getRefDrilldownItem(userId, dashId, kpiKey);
              transaction.set(ddRef, ddStyleConfig, { merge: true });
            }
            ndoc = {
              i: toUpdateKpie.id,
              w: metaGridInfo?.w || 12,
              h: metaGridInfo?.h || 10,
              x: metaGridInfo?.x || 0,
              y: metaGridInfo?.y || 1000,
            };
            const newStateDashLayout2Firestore = layoutUpdate2Firestore(dashLayout, ndoc);
            transaction.update(refDashboardLayout, newStateDashLayout2Firestore);
            transaction = createLog('kpi', 'edit', {
              KpiObject, dashData: dash.data(), userDoc, kpiKey, kpiId: ndoc.i, dashId,
            }, transaction);
          /// ////////////////
          } else {
            const newKpiDoc = getRefKpiItemList(userId, dashId).doc();
            const KpiObjectDated = {
              ...KpiObject,
              createdAt: firebase.serverTimestamp(),
            };
            transaction.set(newKpiDoc, KpiObjectDated);
            if (ddStyleConfig) {
              const ddRef = getRefDrilldownItem(userId, dashId, newKpiDoc.id);
              transaction.set(ddRef, ddStyleConfig, { merge: true });
            }

            // UPDATE dashboardlayout
            ndoc = {
              i: newKpiDoc.id,
              w: metaGridInfo?.w || 12,
              h: metaGridInfo?.h || 10,
              x: 0,
              y: 1000,
            };
            const layoutRaw = await refDashboardLayout.get();
            const layoutData = layoutRaw.data() || defaultLayout;
            const newStateDashLayout2Firestore = layoutInsert2Firestore(layoutData, ndoc);
            transaction.set(refDashboardLayout, newStateDashLayout2Firestore, { merge: true });
            transaction = createLog('kpi', 'add', {
              KpiObject, dashData: dash.data(), userDoc, kpiKey, kpiId: ndoc.i, dashId,
            }, transaction);
          }
          // UPDATE DASHBOARD_DOC
          const oldDatabases = dash.get('databases') || [];
          const databases = !oldDatabases.includes(metaGen.database)
            ? [...oldDatabases, metaGen.database] : oldDatabases;
          transaction.update(refDashboard, {
            databases,
            lastUpdateUser: firebase.serverTimestamp(),
            lastChangesAffect: CHANGES.kpis,
          });

          // UPDATING FILE PERMISSIONS FOR ALREADY SHARED USERS
          // AND LASTUPDATUSER
          const alreadyShared = dash.get('sharedWith') || {};
          if (Object.keys(alreadyShared).length) {
            await setLastUpdateUserOnShared(dash.data(), CHANGES.kpis);
            transaction = notificationTriggers('create_update', {
              KpiObject, dashData: dash.data(), userDoc, kpiKey, kpiId: ndoc.i, dashId,
            }, transaction);
          }
          if (!oldDatabases.includes(metaGen.database)
            && Object.keys(alreadyShared).length > 0
            && metaGen.fileOwner === userId) {
            const fileRes = await changeFilePermission(
              metaGen.database, Object.keys(alreadyShared),
            );
            if (fileRes.error) {
              return fileRes.error;
            }

            // const idsToMetadata = {};
            // Object.keys(alreadyShared).forEach((id) => {
            //   idsToMetadata[`shared_${id}`] = true;
            // });
            // await firebase.updateCustomFileMetadataUsingPath(`/users/${userId}/databases/${metaGen.database}`, idsToMetadata);
          }

          // notification
        }));
      return { error: false, msg: '' };
    } catch (er) {
      console.log(er);
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.createCard,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, [userDoc]);

  /// ////////////// REMOVE CARD ////////////////////
  const removeCards = useCallback(async (userId, dashId, cardsToRemove, allCards, layout) => {
    try {
      const dashRef = getRefDashboardItem(userId, dashId);
      const updatedData = {};
      await getTransaction((transaction) => transaction.get(dashRef).then(async (dashDoc) => {
        let tr = transaction;
        const dashData = dashDoc.data();
        const docChanges = {
          lastUpdateUser: firebase.serverTimestamp(),
          lastChangesAffect: CHANGES.kpis,
        };
        const removedIds = [];
        cardsToRemove.forEach((rCard) => {
          // deletes the card
          tr.delete(getRefKpiItem(userId, dashId, rCard.id));
          // delete drilldown style
          tr.delete(getRefDrilldownItem(userId, dashId, rCard.id));
          // Mural log
          tr = createLog((['label', 'smartLabel', 'Content'].includes(rCard.type) ? 'insight' : 'kpi'), 'remove', {
            KpiObject: rCard, userDoc, kpiId: rCard.id, dashId,
          }, tr);
          // Notification log
          if (dashData.sharedWith) {
            tr = notificationTriggers('kpi_delete', {
              dashdoc: dashData, cardData: rCard, cardId: rCard.id, userDoc, dashId,
            }, tr);
          }
          removedIds.push(rCard.id);
        });
        const cardsLeft = allCards.filter((c) => (
          c.status === 'active' && !removedIds.includes(c.id) && Boolean(c.database)
        ));
        // Update dashboard databases list
        const dbsUpdated = [...new Set(cardsLeft.map((c) => c.database))];
        if (!isEqual(dbsUpdated, dashData.databases)) {
          docChanges.databases = dbsUpdated;
        }
        // Update dashboard global filters list
        if (docChanges.databases && dashData.globalFilters?.length > 0) {
          docChanges.globalFilters = dashData.globalFilters.filter((gf) => (
            docChanges.databases.includes(gf.database)
          ));
        }
        // Update on shared
        Object.keys(dashData.sharedWith ?? {}).forEach((id) => {
          tr.set(
            getRefSharedItem(id, `${currentUser.uid}_${currentDashId}`),
            { lastUpdateUser: firebase.serverTimestamp() },
            { merge: true },
          );
        });
        // Update layout
        const cardsLeftIds = allCards.filter((c) => (
          !removedIds.includes(c.id)
        )).map((d) => d.id).filter((id) => id !== undefined);
        const layoutUpdated = Object.entries(layout).reduce((aux, [k, v]) => {
          if (v === undefined || k === undefined) return aux;
          if (!Array.isArray(v)) aux[k] = v;
          else aux[k] = v.filter((l) => l !== undefined && cardsLeftIds.includes(l.i)) ?? [];
          return aux;
        }, {});
        tr.set(
          getRefKpiLayout(userId, dashId, 'kpis'),
          layoutAll2Firestore(layoutUpdated),
          { merge: true },
        );
        updatedData.layout = layoutUpdated;
        updatedData.dashDoc = docChanges;
        updatedData.kpis = allCards.filter((c) => !removedIds.includes(c.id));
        // Update dashboard doc
        tr.update(dashRef, docChanges);
      }));
      return { error: false, msg: '', updatedData };
    } catch (er) {
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.removeCards,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, []);

  /// ////////////////// CLONE CARD ////////////////////
  const cloneCard = useCallback(async (userId, dashId, toCloneCard, layout) => {
    try {
      const batch = getBatch();
      const refKpiItemList = getRefKpiItemList(userId, dashId);
      const kpiNewDocument = refKpiItemList.doc();
      const getCardData = () => {
        const objData = {
          ...toCloneCard,
          name: `clone de ${toCloneCard.name}`,
          clonned_at: firebase.serverTimestamp(),
        };
        if (toCloneCard.meta) objData.meta = JSON.stringify(toCloneCard.meta);
        if (toCloneCard.data) objData.data = JSON.stringify(toCloneCard.data);
        const { DDStyles: toDDStyles, ...tmpStyle } = toCloneCard.style;
        if (toDDStyles) {
          batch.set(getRefDrilldownItem(userId, dashId, kpiNewDocument.id), toDDStyles);
        }
        if (toCloneCard.style) objData.style = JSON.stringify(tmpStyle);
        return objData;
      };

      batch.set(kpiNewDocument, getCardData());
      const stateDashboardLayout2Firestore = layoutAll2Firestore(layout);
      const originalItemLayout = [...stateDashboardLayout2Firestore.lg].filter(
        (v) => v.i === toCloneCard.id,
      );

      const refDashboardLayout = getRefKpiLayout(userId, dashId);
      const ndoc = {
        i: kpiNewDocument.id,
        w: originalItemLayout?.[0]?.w || 0,
        h: originalItemLayout?.[0]?.h || 0,
        x: originalItemLayout?.[0]?.x || 0,
        y: 1000,
      };
      const layouts2 = layoutInsert2Firestore(layout, ndoc);
      batch.update(refDashboardLayout, layouts2);

      // update LAST UPDATE USER ON SHAREDS.
      const refDashboard = getRefDashboardItem(userId, dashId);
      await getTransaction((transaction) => transaction.get(refDashboard).then(async (dashdocRaw) => {
        const dashdoc = dashdocRaw.data();
        if (dashdoc.sharedWith && Object.keys(dashdoc.sharedWith).length) {
          await setLastUpdateUserOnShared(dashdoc, CHANGES.kpis);
        }
      }));
      batch.set(refDashboard, {
        lastUpdateUser: firebase.serverTimestamp(),
        lastChangesAffect: CHANGES.kpis,
      }, { merge: true });

      await batch.commit();
      return { error: false, msg: '', clonedCardId: kpiNewDocument.id };
    } catch (er) {
      console.log(er);
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.cloneCard,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, []);

  const subsetTableReachedLimitInDash = async (userId, dashId, subsetTableLimit) => {
    const infos = await getAllInfos(userId, dashId);
    const { kpis } = infos;
    const subsetTablesInDash = kpis.filter((k) => k.type === 'SubsetTable');
    return subsetTablesInDash.length >= subsetTableLimit;
  };

  const checkSubsetTableLimit = async (
    kpisRef, dashName, plan, newSubsetTableCount, subsetTableLimit,
  ) => {
    let msg = null;
    const subTableDocs = await kpisRef.where('type', '==', 'SubsetTable').get();
    if ((subTableDocs?.docs?.length ?? 0) + newSubsetTableCount > subsetTableLimit) {
      msg = `O dashboard "${dashName}" atingiu o limite de Subtabelas permitido `;
      msg += plan !== 'premium' ? (
        'pelo seu plano. Para alterar o plano, entre em contato com o suporte.'
      ) : 'por dashboard.';
    }
    return msg;
  };

  const changeSharedFilePermission = async (userIds, filesIds) => Promise.all(
    filesIds.map(async (fId) => {
      const resObj = { id: fId, msg: '', error: false };
      const fileRes = await changeFilePermission(fId, userIds);
      if (fileRes.error) {
        resObj.error = true;
        resObj.msg = 'Não foi possível compartilhar o arquivo!';
      }
      return resObj;
    }),
  );

  const transferKpis = useCallback(async (
    userId,
    selectedKpis,
    targetDashsIds,
    layout,
    subsetTableLimit,
    plan,
  ) => {
    try {
      const newKpisLayouts = [];
      let subsetTableCount = 0;
      const newKpisCards = selectedKpis.map((selected) => {
        // New card data
        const { updatedAt: _, ...kpiData } = selected;
        kpiData.createdAt = firebase.serverTimestamp();
        kpiData.transferedAt = firebase.serverTimestamp();
        if (selected.meta) kpiData.meta = JSON.stringify(selected.meta);
        if (selected.data) kpiData.data = JSON.stringify(selected.data);
        if (selected.style) {
          const { DDStyles, ...mainStyle } = selected.style;
          kpiData.style = JSON.stringify(mainStyle);
          if (DDStyles) kpiData.DDStyles = DDStyles;
        }
        // New card layout
        const stateDashboardLayout2Firestore = layoutAll2Firestore(layout);
        const originalLayoutKpi = [...stateDashboardLayout2Firestore.lg].filter(
          (v) => v.i === selected.id,
        );
        newKpisLayouts.push({
          w: originalLayoutKpi?.[0]?.w || 0,
          h: originalLayoutKpi?.[0]?.h || 0,
          x: 0,
          y: 1000,
        });
        if (selected.type === 'SubsetTable') subsetTableCount += 1;
        return kpiData;
      });
      const usersToShare = new Set();
      const filesToShare = new Set();
      const resDashs = await Promise.all(targetDashsIds.map(async (tDashId) => {
        const resDoc = { error: true, msg: "Erro ao transferir KPI's", dashId: tDashId };
        try {
          const dashRef = getRefDashboardItem(userId, tDashId);
          const kpisRef = getRefKpiItemList(userId, tDashId);
          const layoutRef = getRefKpiLayout(userId, tDashId);
          await getTransaction((transaction) => transaction.get(dashRef).then(async (dashDoc) => {
            const tr = transaction;
            const dashData = dashDoc.data();
            const layoutDoc = await layoutRef.get();
            let layoutData = layoutDoc.exists() ? layoutDoc.data() : defaultLayout;
            // Check subsetTable limit
            if (subsetTableCount > 0) {
              const alertMsg = await checkSubsetTableLimit(
                kpisRef, dashData.name, plan, subsetTableCount, subsetTableLimit,
              );
              if (alertMsg) {
                resDoc.raw = alertMsg;
                return;
              }
            }
            // Dash databases update
            const dbsUpdated = new Set(dashData.databases ?? []);
            newKpisCards.forEach((nKpi, i) => {
              if (nKpi.database && !dbsUpdated.has(nKpi.database)) {
                const metaGen = typeof nKpi.meta === 'string' ? JSON.parse(nKpi.meta) : nKpi.meta;
                const sharedUsers = Object.keys(dashData.sharedWith || {});
                if (sharedUsers.length > 0 && metaGen.fileOwner === userId) {
                  sharedUsers.forEach((u) => usersToShare.add(u));
                  filesToShare.add(nKpi.database);
                }
                dbsUpdated.add(nKpi.database);
              }
              // Add new kpi to dash
              const nKpiDoc = kpisRef.doc();
              const { DDStyles, ...mainNKpi } = nKpi;
              tr.set(nKpiDoc, { ...mainNKpi, id: nKpiDoc.id });
              if (DDStyles) tr.set(getRefDrilldownItem(userId, tDashId, nKpiDoc.id), DDStyles);
              // Add new layout
              layoutData = layoutInsert2Firestore(
                layoutData,
                { ...newKpisLayouts[i], i: nKpiDoc.id },
              );
            });
            tr.update(dashRef, { databases: [...dbsUpdated] });
            tr.set(layoutRef, layoutData, { merge: true });
            resDoc.error = false;
            resDoc.msg = '';
          }));
          return resDoc;
        } catch (err) {
          resDoc.msg = firestoreErrors(err.code) || errorLabels.useGridKpi.transferKpis;
          resDoc.raw = err.toString();
          return resDoc;
        }
      }));
      const errors = resDashs.filter((rd) => rd.error);
      let fileRes = [];
      if (errors.length !== targetDashsIds.length) {
        fileRes = await changeSharedFilePermission([...usersToShare], [...filesToShare]);
      }
      return {
        error: false,
        msg: '',
        updated: resDashs.filter((rd) => !rd.error),
        errors,
        fileErrors: fileRes.filter((fres) => fres.error),
      };
    } catch (er) {
      console.log(er);
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.transferKpis,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, []);

  /** ****************** SNAPSHOTS  ******************* */
  /// /////////////// add SNAP //////////////////
  async function deleteSnapCollection(userId, dashId, snapName, batch = getBatch()) {
    const ref = getRefKpiItemList(userId, dashId, snapName);
    const getting = await ref.get();

    getting.docs.forEach((doc) => batch.delete(doc));

    return batch;
  }

  function compare(a, b) {
    const toCompare = b.snapId || b;
    const aux = a.snapId || a;
    return toCompare.localeCompare(aux, undefined, {
      numeric: true,
      sensitivity: 'base',
    });
  }

  const saveSnapshot = useCallback(
    async (userId, dashId, snapName, oldSnaps, cardList, cardsLayout, deleteOlder) => {
      try {
        const orderedOldSnaps = oldSnaps.sort(compare);
        const snapId = new Date().toISOString();
        const refSnap = getRefKpiItemList(userId, dashId, snapId);
        const dashboardRef = getRefDashboardItem(userId, dashId);
        let batch = getBatch();

        const refSnapLayout = getRefKpiLayout(userId, dashId, snapId);
        batch.set(refSnapLayout, layoutAll2Firestore(cardsLayout));

        // copy kpis
        cardList.forEach((card) => {
          const newKpi = refSnap.doc(card.id);
          batch.set(newKpi, {
            ...card,
            meta: card.meta ? JSON.stringify(card.meta) : null,
            data: card.data ? JSON.stringify(card.data) : null,
            style: card.style ? JSON.stringify(card.style) : null,
          });
        });

        if (deleteOlder) {
          batch = await deleteSnapCollection(userId, dashId, orderedOldSnaps.shift(), batch);
        }

        const toSaveSnaps = [{ name: snapName, snapId }, ...orderedOldSnaps];

        batch.update(dashboardRef, {
          snapshots: toSaveSnaps,
          lastUpdateUser: firebase.serverTimestamp(),
          lastChangesAffect: CHANGES.dashboard,
        });

        batch = createLog('story', 'add', {
          dashId, userDoc, snapId, snapName,
        }, batch);

        await batch.commit();

        // update LAST UPDATE USER ON SHAREDS.

        await getTransaction((transaction) => transaction.get(dashboardRef).then(async (dashdocRaw) => {
          const dashdoc = dashdocRaw.data();
          if (dashdoc.sharedWith && Object.keys(dashdoc.sharedWith).length) {
            await setLastUpdateUserOnShared(dashdoc, CHANGES.dashboard);
          }
        }));

        return { error: false, msg: '' };
      } catch (er) {
        return {
          error: true,
          msg: firestoreErrors(er.code) || errorLabels.useGridKpi.newSnap,
          raw: `Erro do sistema: ${er.toString()}`,
        };
      }
    }, [],
  );

  const scheduleSnapshot = useCallback(async (cronCode, dashId, snapName) => {
    try {
      const token = await getToken(currentUser);
      const opt = {
        ...await getRequestMeta(token, 'PUT', 'JSON'),
        body: JSON.stringify({
          story_cron: cronCode,
          story_name: snapName,
        }),
      };
      const resFetch = await fetch(`${ip}/kpis/story/schedule/${dashId}`, opt);

      if (resFetch.status === 500) {
        return {
          error: true,
          msg: errorLabels.fetchGeneric,
          raw: 'Verifique se existe algum problema com a sua conexão com a internet e tente novamente mais tarde!',
        };
      }

      const json = await resFetch.json();

      if (resFetch.status !== 200) {
        return {
          error: true,
          msg: errorLabels.useGridKpi.scheduleSnap,
          raw: json.error,
        };
      }
      return { error: false, msg: null, res: json.info };
    } catch (er) {
      console.log(er);
      return { error: true, message: errorLabels.useGridKpi.scheduleSnap, raw: `Erro do sistema: ${er.toString()}` };
    }
  }, [currentUser]);

  const editSnapshot = useCallback(async (userId, dashId, editSnap, oldSnapsFromDoc) => {
    try {
      const dashboardRef = getRefDashboardItem(userId, dashId);
      const oldSnaps = oldSnapsFromDoc || [];
      const attSnaps = oldSnaps.map((old) => {
        if (old.snapId === editSnap.snapId) return editSnap;
        return old;
      });

      await dashboardRef.update({
        snapshots: attSnaps,
        lastUpdateUser: firebase.serverTimestamp(),
        lastChangesAffect: CHANGES.dashboard,
      });

      // update LAST UPDATE USER ON SHAREDS.

      await getTransaction((transaction) => transaction.get(dashboardRef).then(async (dashdocRaw) => {
        const dashdoc = dashdocRaw.data();
        transaction = createLog('story', 'edit', {
          dashId, userDoc, name: editSnap.name,
        }, transaction);
        if (dashdoc.sharedWith && Object.keys(dashdoc.sharedWith).length) {
          await setLastUpdateUserOnShared(dashdoc, CHANGES.dashboard);
        }
      }));

      return { error: false, msg: '' };
    } catch (er) {
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.editSnap,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, []);

  /// ///////// REMOVE SNAP ///////////////////
  const removeSnap = useCallback(async (userId, dashId, toDeleteSnap, oldSnaps) => {
    try {
      const dashboardRef = getRefDashboardItem(userId, dashId);
      const attSnaps = oldSnaps.filter((old) => old.snapId !== toDeleteSnap.snapId);

      let batch = getBatch();

      batch.update(dashboardRef, {
        snapshots: attSnaps,
        lastUpdateUser: firebase.serverTimestamp(),
        lastChangesAffect: CHANGES.dashboard,
      });
      batch = await deleteSnapCollection(userId, dashId, toDeleteSnap.snapId, batch);

      batch = createLog('story', 'remove', {
        dashId, userDoc, snapId: toDeleteSnap.snapId, snapName: toDeleteSnap.name,
      }, batch);

      // update LAST UPDATE USER ON SHAREDS.

      await getTransaction((transaction) => transaction.get(dashboardRef).then(async (dashdocRaw) => {
        const dashdoc = dashdocRaw.data();
        if (dashdoc.sharedWith && Object.keys(dashdoc.sharedWith).length) {
          await setLastUpdateUserOnShared(dashdoc, CHANGES.dashboard);
        }
      }));

      await batch.commit();
      return { error: false, msg: '' };
    } catch (er) {
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.removeSnap,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, []);

  /// ///////////// DONWLOAD RELATORIO /////////////
  const downloadReportFromCard = useCallback(async (dashId, cardId, reportName, filters) => {
    try {
      const token = await getToken(currentUser);
      const opt = {
        ...await getRequestMeta(token, 'POST', 'JSON'),
        responseType: 'blob',
        body: JSON.stringify({ filters: [...filters] }),
      };
      const resFetch = await fetch(`${ip}/kpis/report/${dashId}/${cardId}`, opt);

      if (resFetch.status !== 200) {
        const json = await resFetch.json();
        return { error: true, msg: json.msg || errorLabels.useGridKpi.getReport, raw: json?.error };
      }
      let safeFileName = 'report.xlsx';
      if (reportName?.length > 0) {
        safeFileName = reportName.split(' ').filter((v) => v).join('_').replace(/[^\w| ]/g, '_');
        safeFileName = `${safeFileName.substring(0, 100)}.xlsx`;
      }

      const blob = await resFetch.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = safeFileName;
      a.click();
      return { error: false, msg: '' };
    } catch (er) {
      return { error: true, msg: errorLabels.generic, raw: `Erro do sistema: ${er.toString()}` };
    }
  }, [currentUser]);

  /// ///////////////// DONWLOAD IMAGE //////////////
  const donwloadImageCard = useCallback(async (cardRef, name) => {
    if (!cardRef) return;
    const canvas = await html2canvas(cardRef, { logging: false });
    const image = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
    const a = document.createElement('a');
    a.href = image;
    a.download = `${name || 'card'}.png`;
    a.click();
  }, []);

  /// /////////// getColumnDependecies ///////////////
  const getColumnDependecies = useCallback((kpis, globalFilters) => {
    const metas = kpis.map((card) => ('meta' in card ? card.meta : null)).filter((kpi) => kpi !== null);
    const columnsRequired = {};
    metas.forEach((kpi) => {
      if (kpi?.columns?.length > 0) {
        columnsRequired[kpi.columns[0].column] = { type: kpi?.columns?.[0]?.type || 'category', description: '' };
      }
      if (kpi?.lines?.length > 0) {
        columnsRequired[kpi.lines[0].column] = { type: kpi?.lines?.[0]?.type || 'category', description: '' };
      }
      if (kpi?.control?.length > 0) {
        columnsRequired[kpi.control[0].column] = { type: kpi?.control?.[0]?.type || 'category', description: '' };
      }
      if (kpi?.filters?.length > 0) {
        kpi.filters.forEach((filter) => {
          if (filter?.column !== kpi?.columns?.[0]?.column) {
            columnsRequired[filter.column] = { type: filter?.type || 'category', description: '' };
          }
        });
      }
      if (kpi?.kpi_type === 'SubsetTable' && kpi?.values?.length > 0) {
        kpi.values.forEach((value) => {
          columnsRequired[value?.column] = { type: value?.type || 'category', description: '' };
        });
      }
      if (kpi?.drilldown?.length > 0) {
        kpi.drilldown.forEach((drill) => {
          columnsRequired[drill.column] = { type: drill?.type || 'category', description: '' };
        });
      }
      // if (globalFilters?.length > 0) {
      //   globalFilters.forEach((gFilter) => {
      //     if (gFilter?.column !== kpi.columns[0]?.column) {
      //       columnsRequired[gFilter.column] = { type: gFilter.type || 'category', description: '' };
      //     }
      //   });
      // }
      if (kpi?.values?.length > 0) {
        kpi.values.forEach((value) => {
          columnsRequired[value.column] = { type: value?.type || 'category', description: '' };
        });
      }
    });

    return columnsRequired;
  }, []);

  /// /////////////// COMMENTS FUNCS /////////////////

  const loadComments = useCallback(async () => {
    try {
      const commentsRaw = await getRefCommentsList(ownerId, currentDashId)
        .orderBy('serverTimestamp', 'asc')
        .where('archived', '==', false)
        .limitToLast(commentsLimitPerLoad)
        .get();

      const comments = commentsRaw.docs.map((c) => ({ ...c.data(), id: c.id }));

      const cursor = comments.length >= commentsLimitPerLoad ? commentsRaw.docs[0] : null;

      return {
        error: false,
        msg: '',
        comments,
        cursor,
      };
    } catch (er) {
      console.log(er);
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.loadComments,
        raw: `Erro do sistema: ${er.toString()}`,
        comments: [],
        cursor: null,
      };
    }
  }, [ownerId, currentDashId]);

  const loadMoreComments = useCallback(async (cursor) => {
    if (!cursor) {
      return {
        error: false, comments: [], cursor: null, msg: '',
      };
    }
    try {
      const dataCursor = cursor.data();
      const commentsRaw = await getRefCommentsList(ownerId, currentDashId)
        .orderBy('serverTimestamp', 'desc')
        .startAfter(cursor)
        .where('archived', '==', false)
        .where('serverTimestamp', '<', dataCursor.serverTimestamp)
        .limit(commentsLimitPerLoad)
        .get();

      const comments = commentsRaw.docs.map((c) => ({ ...c.data(), id: c.id })).reverse();
      const newCursor = comments.length >= commentsLimitPerLoad ? commentsRaw.docs[0] : null;
      return {
        error: false, msg: '', comments, cursor: newCursor,
      };
    } catch (er) {
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.loadMoreComments,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, [ownerId, currentDashId]);

  const addComment = useCallback(async (text, mentions) => {
    const comment = {
      text,
      timestamp: new Date().getTime(),
      authorId: currentUser.uid,
      author: currentUser.email,
      mentions,
      archived: false,
      image: currentUser.photoURL,
    };

    try {
      const CommentsListRef = getRefCommentsList(ownerId, currentDashId);
      const dashDoc = await getDashboard(ownerId, currentDashId);
      const doc = CommentsListRef.doc();
      let batch = getBatch();
      batch.set(doc, {
        ...comment,
        id: doc.id,
        serverTimestamp: firebase.serverTimestamp(),
      });
      if (comment.mentions.users.length > 0) {
        batch = notificationTriggers('comment', { comment, userDoc, dashDoc }, batch);
      }
      const dashDocRef = getRefDashboardItem(ownerId, currentDashId);
      batch.update(dashDocRef, {
        lastUpdateUser: firebase.serverTimestamp(),
        lastChangesAffect: CHANGES.kpis,
      });
      await batch.commit();

      return { error: false, msg: '', comment: { ...comment, id: doc.id } };
    } catch (er) {
      console.log(er);
      const localErroId = `${uuidv4()}_error`;
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.addComment,
        raw: `Erro do sistema: ${er.toString()}`,
        comment: { ...comment, error: true, id: localErroId },
      };
    }
  }, [ownerId, currentDashId, currentUser]);

  const editComment = useCallback(async (text, mentions, commentId) => {
    const editInfos = {
      text,
      edited: true,
      editedTimestamp: new Date().getTime(),
      mentions,
    };
    try {
      const batch = getBatch();
      const CommentsDocRef = await getRefComment(ownerId, currentDashId, commentId);
      batch.set(CommentsDocRef, {
        ...editInfos,
        serverEditedTimestamp: firebase.serverTimestamp(),
      }, { merge: true });

      const dashDocRef = getRefDashboardItem(ownerId, currentDashId);
      batch.update(dashDocRef, {
        lastUpdateUser: firebase.serverTimestamp(),
        lastChangesAffect: CHANGES.kpis,
      });
      await batch.commit();

      return { error: false, msg: '', editInfos };
    } catch (er) {
      console.log(er);
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.editComment,
        raw: `Erro do sistema: ${er.toString()}`,
        editInfos: { ...editInfos, error: true },
      };
    }
  }, [ownerId, currentDashId]);

  const archiveComment = useCallback(async (commentId) => {
    try {
      const batch = getBatch();
      const CommentsRaw = await getRefComment(ownerId, currentDashId, commentId);
      batch.set(CommentsRaw, {
        archived: true,
        archivedTimestamp: firebase.serverTimestamp(),
      }, { merge: true });

      const dashDocRef = getRefDashboardItem(ownerId, currentDashId);
      batch.update(dashDocRef, {
        lastUpdateUser: firebase.serverTimestamp(),
        lastChangesAffect: CHANGES.kpis,
      });
      await batch.commit();

      return { error: false, msg: '' };
    } catch (er) {
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.archiveComment,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, [ownerId, currentDashId]);

  // /////////////// Descrição /////////////////// //
  const setDescription = useCallback(async (description) => {
    try {
      const ref = getRefDashboardItem(ownerId, currentDashId);
      await ref.set({
        description,
        lastUpdateUser: firebase.serverTimestamp(),
        lastChangesAffect: CHANGES.dashboard,
      }, { merge: true });

      return { error: false, msg: '' };
    } catch (er) {
      console.log(er);
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.setDescription,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, [ownerId, currentDashId]);

  const setCardStyles = useCallback(async (cardStyles) => {
    try {
      const ref = getRefDashboardItem(ownerId, currentDashId);
      await ref.set({
        cardStyles,
        lastUpdateUser: firebase.serverTimestamp(),
        lastChangesAffect: CHANGES.dashboard,
      }, { merge: true });

      return { error: false, msg: '' };
    } catch (er) {
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.setCardStyles,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, [ownerId, currentDashId]);

  // ////////////// create Template ////////////// //
  /**
   * templateObj = {
   *  category: '',
   *  columnsRequired: {
   *    ['nome da variável']: {
   *        type: ' ',
   *        description: '',
   *     }
   *    }
   *  image: '',
   *  keywords: ['', ''...],
   *  name: '',
   *  tutorialLink: 'www....',
   *
   * }
   */
  const createTemplate = useCallback(async (
    templateObj,
    kpiItemList,
    stateKpisLayout,
  ) => {
    try {
      const templateList = getRefTemplateList();
      const newTemplate = templateList.doc();

      const batch = getBatch();

      const refLayoutDoc = getRefTemplateLayout(newTemplate.id);
      batch.set(refLayoutDoc,
        layoutAll2Firestore(stateKpisLayout),
        { merge: true });

      const templateKpis = getRefTemplateKpis(newTemplate.id);
      kpiItemList.forEach((card) => {
        const newKpi = templateKpis.doc(card.id);
        const cardObj = { ...card, style: JSON.stringify(card.style) };
        if (!['label', 'smartLabel'].includes(card.type)) {
          cardObj.meta = JSON.stringify(card.meta);
          if (card.type !== 'Content') {
            cardObj.data = JSON.stringify(card.data);
          }
        }
        batch.set(newKpi, cardObj);
      });

      let imageUrl = isString(templateObj.imageFile) ? templateObj.imageFile : '';
      if (isFile(templateObj.imageFile)) {
        imageUrl = templateObj.imageFile
          ? await firebase.uploadImage('system/templates', templateObj.imageFile)
          : await firebase.uploadImage('system/templates', { name: 'defaultimg.png' });
      }

      const newTemplateObj = {
        image: imageUrl,
        columnsRequired: templateObj.variables,
        ...templateObj,
      };

      delete newTemplateObj.variables;
      delete newTemplateObj.imageFile;

      batch.set(newTemplate, {
        ...newTemplateObj,
        created_at: firebase.serverTimestamp(),
      });

      await batch.commit();
      return { error: false, msg: '' };
    } catch (er) {
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.createTemplate,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, [userDoc]);

  const editTemplate = useCallback(async (
    templateId,
    templateObj,
  ) => {
    try {
      const oldTemplate = getRefTemplateDoc(templateId);
      const batch = getBatch();

      let imageUrl = isString(templateObj.imageFile) ? templateObj.imageFile : '';
      if (isFile(templateObj.imageFile)) {
        imageUrl = templateObj.imageFile
          ? await firebase.uploadImage('system/templates', templateObj.imageFile)
          : await firebase.uploadImage('system/templates', { name: 'defaultimg.png' });
      }

      const editedTemplateObj = {
        image: imageUrl,
        columnsRequired: templateObj.variables,
        ...templateObj,
      };

      delete editedTemplateObj.variables;
      delete editedTemplateObj.imageFile;

      batch.update(oldTemplate, {
        ...editedTemplateObj,
        last_update: firebase.serverTimestamp(),
      });

      await batch.commit();
      return { error: false, msg: '' };
    } catch (er) {
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.editTemplate,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, [userDoc]);

  const deleteTemplate = useCallback(async (templateId) => {
    try {
      const token = await getToken(currentUser);
      const opt = {
        ...await getRequestMeta(token, 'DELETE', 'JSON'),
      };
      const resFetch = await fetch(`${ipAdmin}/connect/template/${templateId}`, opt);
      if (resFetch.status === 500) {
        return {
          error: true,
          msg: errorLabels.fetchGeneric,
          raw: 'Verifique se existe algum problema com a sua conexão com a internet e tente novamente mais tarde!',
        };
      }
      const json = await resFetch.json();
      if (resFetch.status !== 200) {
        return {
          error: true,
          msg: errorLabels.useGridKpi.deleteTemplate,
          raw: json.error,
        };
      }
      return { error: false, msg: '' };
    } catch (er) {
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.deleteTemplate,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, [currentUser]);

  // Gen public data
  const genPublicKpis = useCallback(async (dashDoc, operation, pwd, expDt) => {
    try {
      const {
        error, publicUrl, localTimestamp, passwordProtected,
      } = await genPublicKpisFunc(userDoc, dashDoc, operation, pwd, expDt);
      if (error) {
        return {
          error,
          link: '',
        };
      }
      return {
        error: false, msg: '', publicUrl, localTimestamp, passwordProtected,
      };
    } catch (er) {
      console.log(er);
      return {
        error: true,
        msg: firestoreErrors(er.code),
        raw: `Erro do sistema: ${er.toString()}`,
        link: '',
      };
    }
  }, [userDoc]);

  const getPublicKpis = useCallback(async (gToken, dashOwnerId, dashId, password) => {
    try {
      const body = { dashId, ownerId: dashOwnerId };
      if (password) body.password = password;
      const opt = {
        ...getPublicRequestMeta(gToken, 'POST', 'JSON'),
        body: JSON.stringify(body),
      };
      const resFetch = await fetch(`${ip}/kpis/public`, opt);
      const json = await resFetch.json();

      if (resFetch.status !== 200) {
        return {
          error: true,
          code: json.code ?? undefined,
          msg: errorLabels.useGridKpi.getPublicKpis,
          raw: json.error,
        };
      }

      const kpis = await Promise.all(
        Object.entries(json.kpis).map(
          async ([id, kpi]) => ({ ...await parseKpiData(kpi), id }),
        ),
      );
      return {
        error: false,
        msg: '',
        layout: json.layout,
        dashDoc: json.doc,
        kpis,
      };
    } catch (er) {
      console.log(er);
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.getPublicKpis,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, []);

  const getTemplateKpis = useCallback(async (dashId) => {
    try {
      const layoutRef = getRefTemplateLayout(dashId);
      const dashRef = getRefTemplateDoc(dashId);
      const kpisRef = getRefTemplateKpis(dashId);

      const [layoutRaw, dashRaw, kpisRaw] = await Promise.all([
        layoutRef.get(), dashRef.get(), kpisRef.get(),
      ]);

      const layout = layoutRaw.data();
      const dashDoc = { ...dashRaw.data(), id: dashId };
      const kpis = await Promise.all(
        kpisRaw.docs.map(async (k) => ({ ...await parseKpiData(k.data()), id: k.id })),
      );
      // const kpis = kpisRaw.docs.map((d) => ({ ...parseKpi(d.data()), id: d.id }));

      return {
        error: false,
        msg: '',
        layout,
        dashDoc,
        kpis,
      };
    } catch (er) {
      console.log(er);
      return {
        error: true,
        msg: firestoreErrors(er.code),
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, []);

  const setGlobalFilterSelectors = useCallback(async (globalFilters, globalLimits = []) => {
    try {
      const ref = getRefDashboardItem(ownerId, currentDashId);
      await ref.set({
        globalFilters,
        globalLimits,
        lastUpdateUser: firebase.serverTimestamp(),
        lastChangesAffect: CHANGES.filters,
      }, { merge: true });

      return { error: false, msg: '' };
    } catch (er) {
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.setGlobalFilterSelectors,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, [ownerId, currentDashId]);

  const exportDashboard = useCallback(async (dashId, dashName) => {
    try {
      const token = await getToken(currentUser);
      const opt = {
        ...await getRequestMeta(token, 'GET'),
        responseType: 'blob',
        // body: JSON.stringify({
        //   dash_id: dashId,
        // }),
      };
      const resFetch = await fetch(`${ip}/kpis/export/${dashId}`, opt);
      if (resFetch.status >= 500) {
        return {
          error: true,
          msg: errorLabels.fetchGeneric,
          raw: 'Verifique se existe algum problema com a sua conexão com a internet e tente novamente mais tarde!',
        };
      }

      if (resFetch.status !== 200) {
        const json = await resFetch.json();
        return {
          error: true,
          msg: errorLabels.useGridKpi.exportDashboard,
          raw: json.error,
        };
      }

      const blob = await resFetch.blob();
      const url = URL.createObjectURL(blob);
      const aNode = document.createElement('a');
      aNode.href = url;
      aNode.download = `${dashName}.zip`;
      aNode.click();

      return { error: false, msg: '' };
    } catch (er) {
      console.log(er);
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.exportDashboard,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, []);

  const importDashboard = useCallback(async (file, dashName) => {
    try {
      const token = await getToken(currentUser);

      const data = new FormData();
      data.append('dashboard', file);
      const opt = { ...await getRequestMeta(token, 'POST'), body: data };

      const resFetch = await fetch(`${ip}/kpis/import?${new URLSearchParams({
        dashboard_name: dashName,
      })}`, opt);
      const json = await resFetch.json();

      if (resFetch.status >= 500) {
        return {
          error: true,
          msg: errorLabels.fetchGeneric,
          raw: 'Verifique se existe algum problema com a sua conexão com a internet e tente novamente mais tarde!',
        };
      }

      if (resFetch.status !== 200) {
        return { error: true, msg: errorLabels.useGridKpi.importDashboard, raw: json.error };
      }
      return { error: false, msg: null, res: json.info };
    } catch (er) {
      console.log(er);
      return { error: true, msg: errorLabels.useGridKpi.importDashboard, raw: `Erro do sistema: ${er.toString()}` };
    }
  }, [currentUser]);

  const genAssistantKpis = useCallback(async (fileId, dashboardId, kpisList) => {
    try {
      const token = await getToken(currentUser);
      const opt = {
        ...await getRequestMeta(token, 'POST', 'JSON'),
        body: JSON.stringify({ fileId, dashboardId, kpisList }),
      };
      const resFetch = await fetch(`${ip}/kpis/quick`, opt);
      const json = await resFetch.json();

      if (resFetch.status !== 200) {
        return {
          error: true,
          msg: errorLabels.useGridKpi.genAssistantKpis,
          raw: json.error,
        };
      }
      return { error: false, dashid: json.info.dash_id };
    } catch (er) {
      console.log(er);
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.genAssistantKpis,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, [currentUser]);

  const getDashResumes = useCallback(async () => {
    try {
      const resumesRaw = await getRefDashResumes(ownerId, currentDashId).get();
      const resumesList = [];
      resumesRaw.forEach((doc) => {
        const datum = doc.data();
        resumesList.push([
          doc.id,
          {
            id: doc.id,
            createdAt: new Date(datum.created_at),
            finishedAt: datum.finished_at ? new Date(datum.finished_at) : undefined,
            response: datum.resposta,
            status: datum.status,
            resumes: null,
          },
        ]);
      });
      resumesList.sort((a, b) => a.createdAt > b.createdAt);
      return new Map(resumesList);
    } catch (er) {
      console.log(er);
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.getDashResumes,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, [currentUser]);

  const getKpisResumes = useCallback(async (resumeKey) => {
    try {
      const resumesRaw = await getRefKpisResumes(ownerId, currentDashId, resumeKey).get();
      const resumesList = [];
      resumesRaw.forEach((doc) => {
        const datum = doc.data();
        resumesList.push([
          doc.id,
          {
            id: doc.id,
            createdAt: new Date(datum.created_at),
            prompt: datum.prompt,
            response: datum.resposta,
          },
        ]);
      });
      resumesList.sort((a, b) => a.createdAt > b.createdAt);
      return new Map(resumesList);
    } catch (er) {
      console.log(er);
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.getDashResumes,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, [currentUser]);

  const genDashKpisResumes = useCallback(async () => {
    try {
      const token = await getToken(currentUser);
      const opt = {
        ...await getRequestMeta(token, 'POST', 'JSON'),
        body: JSON.stringify({ dash_id: currentDashId }),
      };
      const resFetch = await fetch(`${ip}/kpis/dash_resume`, opt);
      const json = await resFetch.json();

      if (resFetch.status !== 200) {
        return {
          error: true,
          msg: errorLabels.useGridKpi.genDashKpisResumes,
          raw: json.error,
        };
      }
      const path = json.info.split('/');
      return path[path.length - 1];
    } catch (er) {
      console.log(er);
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.genDashKpisResumes,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, [currentUser]);

  const setResumesListener = useCallback((resumeKey) => {
    try {
      const kpisResumesRef = getRefKpisResumes(ownerId, currentDashId, resumeKey);
      const dashResumeRef = getRefDashResume(ownerId, currentDashId, resumeKey);
      const listener = getListener();
      const detachKpis = listener(kpisResumesRef, (snapshots) => {
        snapshots.docChanges().forEach(({ doc }) => {
          const datum = doc.data();
          dispatch({
            type: 'updateDashResumeKpi',
            key: resumeKey,
            data: [
              doc.id,
              {
                id: doc.id,
                createdAt: new Date(datum.created_at),
                prompt: datum.prompt,
                response: datum.resposta,
              },
            ],
          });
        });
      });
      const detachDash = listener(dashResumeRef, (snapshot) => {
        if (snapshot.exists()) {
          const datum = snapshot.data();
          dispatch({
            type: 'updateDashResume',
            key: resumeKey,
            data: {
              id: snapshot.id,
              createdAt: new Date(datum.created_at),
              prompt: datum.prompt,
              response: datum.resposta,
              status: datum.status,
            },
          });
        }
      });
      return () => {
        detachKpis();
        detachDash();
      };
    } catch (er) {
      console.log(er);
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.getDashResumes,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, [currentUser]);

  const getKpisFromResume = useCallback(async (resumeKey) => {
    try {
      const kpisRaw = await getRefKpisFromResume(ownerId, currentDashId, resumeKey).get();
      const kpisMap = {};
      kpisRaw.forEach((doc) => {
        const datum = doc.data();
        kpisMap[doc.id] = {
          ...datum,
          id: doc.id,
        };
        if (!['label', 'smartLabel'].includes(datum.type)) {
          if (datum.style) kpisMap[doc.id].style = JSON.parse(datum.style);
          if (datum.data) kpisMap[doc.id].data = JSON.parse(datum.data);
        }
        if (datum.meta) kpisMap[doc.id].meta = JSON.parse(datum.meta);
      });
      return kpisMap;
    } catch (er) {
      console.log(er);
      return {
        error: true,
        msg: firestoreErrors(er.code) || errorLabels.useGridKpi.getKpisFromResume,
        raw: `Erro do sistema: ${er.toString()}`,
      };
    }
  }, [currentUser]);

  const middleware = useCallback(async (action) => {
    // console.log('[users] middleware: ', action);
    switch (action.type) {
      case 'loadCards': {
        setLoading(true);
        const getRes = await getAllInfos(ownerId, currentDashId, action.collection || 'kpis');
        if (getRes.error) {
          setLoading(false);
        } else {
          dispatch({
            type: 'loadCards',
            kpis: getRes.kpis,
            kpisLayout: getRes.kpisLayout,
            dashboardDoc: getRes.dashboardDoc,
            collection: action.collection || 'kpis',
          });
        }
        return getRes;
      }

      case 'loadLiveCards': {
        setLoading(true);
        const getRes = await getAllInfosLive(ownerId, currentDashId);
        if (getRes.error) {
          setLoading(false);
        } else {
          dispatch({
            type: 'loadLiveCards',
          });
        }
        return getRes;
      }

      case 'loadLayoutAndDash': {
        setLoading(true);
        const [dashboardDoc, kpisLayout] = await Promise
          .all([getDashboard(ownerId, currentDashId), getKpisLayout(ownerId, currentDashId)]);
        dispatch({ type: 'loadLayoutAndDash', dashboardDoc, kpisLayout });
        return { dashboardDoc, kpisLayout };
      }

      case 'loadLayout': {
        setLoading(true);
        const result = await getKpisLayout(ownerId, currentDashId);
        dispatch({ type: 'setLayout', kpisLayout: result });
        return result;
      }

      case 'saveLayout': {
        setLoading(true);
        const saveLytRes = await saveLayout(ownerId, currentDashId, action.kpisLayout);
        if (saveLytRes.error) {
          setLoading(false);
        }
        // else {
        //   dispatch({ type: 'setLayout', kpisLayout: action.kpisLayout });
        // }
        return saveLytRes;
      }

      // salvar comentário do KPI
      case 'saveKpiComment': {
        const { kpiKey, comment } = action;
        const { error, msg, raw } = await saveKpiComment(kpiKey, comment);
        // dispatch({ type: 'saveKpiComment', comment });
        return { error, msg, raw };
      }

      case 'updateKpiShowOnExpand': {
        const { kpiKey, showOnExpand } = action;
        const { error, msg, raw } = await updateKpiShowOnExpand(kpiKey, showOnExpand);
        dispatch({ type: 'updateKpiShowOnExpand', showOnExpand });
        return { error, msg, raw };
      }

      case 'saveKpiValueFilters': {
        const { kpiKey, metaGen, pivotTable } = action;
        const { error, msg, raw } = await saveKpiValueFilters(kpiKey, metaGen, pivotTable);
        // dispatch({ type: 'saveKpiValueFilters', metaGen });
        return { error, msg, raw };
      }

      case 'removeCards': {
        setLoading(true);
        const rmvCardRes = await removeCards(
          ownerId, currentDashId, action.cardsToRemove, action.allCards, action.layout,
        );
        if (rmvCardRes.error) {
          setLoading(false);
        }
        // else {
        //   dispatch({
        //     type: 'removeCards',
        //     updatedData: rmvCardRes.updatedData,
        //   });
        // }
        return rmvCardRes;
      }

      case 'cloneCard': {
        setLoading(true);
        const { toClone, cardslayout } = action;
        const res = await cloneCard(ownerId, currentDashId, toClone, cardslayout);
        if (res.error) {
          setLoading(false);
        }
        // else {
        //   const [clonedCard, kpisLayout] = await Promise.all([
        //     getKpi(ownerId, currentDashId, res.clonedCardId),
        //     getKpisLayout(ownerId, currentDashId),
        //   ]);
        //   dispatch({ type: 'cloneCard', clonedCard, kpisLayout });
        // }
        return res;
      }

      case 'transferKpis': {
        setLoading(true);
        const {
          selectedKpis,
          targetDashsIds,
          layout,
          subsetTableLimit,
          plan,
        } = action;
        const res = await transferKpis(
          ownerId,
          selectedKpis,
          targetDashsIds,
          layout,
          subsetTableLimit,
          plan,
        );
        setLoading(false);
        return res;
      }

      case 'saveKpiCard': {
        setLoading(true);
        const {
          kpiName, kpiKey, cardType, dashLayout, metaGen,
          metaGridInfo, pivotTable, styleConfig, ddStyleConfig,
        } = action;
        const result = await saveKpiCard(
          ownerId,
          currentDashId,
          kpiName,
          kpiKey,
          cardType,
          dashLayout,
          metaGen,
          metaGridInfo,
          pivotTable,
          styleConfig,
          ddStyleConfig,
        );
        setLoading(false);
        return result;
      }

      case 'saveInsightCard': {
        setLoading(true);
        const {
          kpiLayout, labelKey, LabelData, image,
        } = action;
        const result = await saveInsightCard(
          ownerId, currentDashId, userDoc.company, kpiLayout, labelKey, LabelData, image,
        );
        setLoading(false);
        return result;
      }

      case 'getKpiInfo': {
        const { kpiId, snap } = action;
        setLoading(true);
        const res = await getKpi(ownerId, currentDashId, kpiId, snap);
        setLoading(false);
        return res;
      }

      /// ////////// SNAPSHOTS /////////////
      case 'saveSnapshot': {
        setLoading(true);
        const newSnapRes = await saveSnapshot(
          ownerId,
          currentDashId,
          action.snapName,
          action.oldSnaps,
          action.cardList,
          action.cardsLayout,
          action.deleteOlder || false,
        );
        if (newSnapRes.error) setLoading(false);
        // else {
        //   const dashDoc = await getDashboard(ownerId, currentDashId);

        //   dispatch({ type: 'setDashboard', dashboardDoc: dashDoc });
        // }
        return newSnapRes;
      }

      case 'editSnapshot': {
        setLoading(true);
        const { editSnap, oldSnaps } = action;
        const editSnapRes = await editSnapshot(ownerId, currentDashId, editSnap, oldSnaps);
        if (editSnapRes.error) {
          setLoading(false);
        }
        // else {
        //   const dashDoc = await getDashboard(ownerId, currentDashId);
        //   dispatch({ type: 'setDashboard', dashboardDoc: dashDoc });
        // }
        return editSnapRes;
      }

      case 'removeSnapshot': {
        setLoading(true);
        const { toDeleteSnap, oldSnaps } = action;
        const rmvSnap = await removeSnap(ownerId, currentDashId, toDeleteSnap, oldSnaps);
        if (rmvSnap.error) {
          setLoading(false);
        }
        // else {
        //   const dashDoc = await getDashboard(ownerId, currentDashId);
        //   dispatch({ type: 'setDashboard', dashboardDoc: dashDoc });
        // }
        return rmvSnap;
      }

      case 'scheduleSnapshot': {
        setLoading(true);
        const { cronCode, snapName } = action;
        const schedSnap = await scheduleSnapshot(cronCode, currentDashId, snapName);
        if (schedSnap.error) {
          setLoading(false);
        }
        // else {
        //   const dashDoc = await getDashboard(ownerId, currentDashId);
        //   dispatch({ type: 'setDashboard', dashboardDoc: dashDoc });
        // }
        return schedSnap;
      }

      // OTHERS
      case 'downloadReportFromCard': {
        setLoading(true);
        const { cardId, reportName, filters } = action;
        const result = await downloadReportFromCard(currentDashId, cardId, reportName, filters);
        setLoading(false);
        return result;
      }

      case 'getDashInfo': {
        setLoading(true);
        const res = await getDashboard(ownerId, currentDashId);
        setLoading(false);
        return res;
      }

      case 'setDashInfo': {
        const { dashboardDoc } = action;
        dispatch({
          type: 'setDashboard',
          dashboardDoc,
        });
        return {};
      }

      case 'downloadImgCard': {
        setLoading(true);
        const { cardRef, name } = action;
        await donwloadImageCard(cardRef, name);
        setLoading(false);
        return {};
      }

      case 'getColumnDependecies': {
        return getColumnDependecies(action.kpiList, action.globalFilters);
      }

      case 'loadComments': {
        dispatch({ type: 'setCommentsLoading', l: true });
        const {
          error, comments, msg, raw, cursor,
        } = await loadComments();

        if (error) {
          dispatch({ type: 'commentsLoadingError', error: true });
        } else {
          dispatch({ type: 'loadComments', comments, cursor });
        }
        return { error, msg, raw };
      }

      case 'addComment': {
        const {
          error, msg, raw, comment,
        } = await addComment(action.text, action.mentions);
        // dispatch({ type: 'addComment', comment });
        // esquema para saber qnd deu erro. (salvar só no front, flag com addError)
        return { error, msg, raw };
      }

      case 'editComment': {
        const { commentId, text, mentions } = action;
        // action.mentions
        const {
          error, msg, raw, editInfos,
        } = await editComment(text, mentions, commentId);
        if (!error) {
          // dispatch({ type: 'editComment', commentId, editInfos });
        } else {
          dispatch({ type: 'setCommentsLoading', l: false });
          // esquema para saber qnd deu erro. (salvar só no front, flag com editError)
        }
        return { error, msg, raw };
      }

      case 'archiveComment': {
        const { error, msg, raw } = await archiveComment(action.commentId);
        // if (!error) {
        //   dispatch({ type: 'archiveComment', commentId: action.commentId });
        // }

        return { error, msg, raw };
      }

      case 'setDescription': {
        const { description } = action;
        const { error, msg, raw } = await setDescription(description);
        // dispatch({ type: 'setDescription', description });
        return { error, msg, raw };
      }

      case 'loadMoreComments': {
        dispatch({ type: 'setLoadMoreLoading', l: true });
        const {
          msg, error, raw, comments, cursor,
        } = await loadMoreComments(action.cursor);
        if (!error) {
          dispatch({ type: 'loadMoreComments', comments, cursor });
        } else {
          dispatch({ type: 'setLoadMoreLoading', l: false });
        }

        return { error, msg, raw };
      }

      case 'setCardStyles': {
        setLoading(true);
        const result = await setCardStyles(action.cardStyles);
        if (!result.error) {
          // dispatch({ type: 'setCardStyles', cardStyles: action.cardStyles });
        } else {
          setLoading(false);
        }

        return result;
      }

      case 'setGlobalFilterSelectors': {
        setLoading(true);
        const result = await setGlobalFilterSelectors(action.globalFilters, action.globalLimits);
        if (!result.error) {
          // dispatch({
          //   type: 'setGlobalFilterSelectors',
          //   globalFilters: action.globalFilters,
          //   globalLimits: action.globalLimits,
          // });
        } else {
          setLoading(false);
        }

        return result;
      }

      case 'exportDashboard': {
        setLoading(true);
        const { dashId, dashName } = action;
        const result = await exportDashboard(dashId, dashName);
        setLoading(false);
        return result;
      }

      case 'importDashboard': {
        setLoading(true);
        const { file, dashName } = action;
        const result = await importDashboard(file, dashName);
        setLoading(false);
        return result;
      }

      case 'getPlotlyLink': {
        setLoading(true);
        const result = await getPlotlyLink(action.plotlyId);
        setLoading(false);
        return result;
      }

      case 'createTemplate': {
        setLoading(true);
        const { template, kpiItemList, kpisLayout } = action;
        const result = await createTemplate(template, kpiItemList, kpisLayout);
        setLoading(false);
        return result;
      }

      case 'editTemplate': {
        setLoading(true);
        const { templateId, template } = action;
        const result = await editTemplate(templateId, template);
        setLoading(false);
        return result;
      }

      case 'deleteTemplate': {
        setLoading(true);
        const { templateId } = action;
        const result = await deleteTemplate(templateId);
        setLoading(false);
        return result;
      }

      case 'genPublicKpis': {
        setLoading(true);
        const res = await genPublicKpis(
          action.dashId, action.operation, action.pwd, action.expDt,
        );
        if (!res.error) {
          dispatch({
            type: 'attDashDocPublic',
            publicUrl: res.publicUrl,
            publicTimestamp: res.localTimestamp,
            passwordProtected: res.passwordProtected,
          });
        } else {
          setLoading(false);
        }
        return res;
      }

      case 'getPublicKpis': {
        setLoading(true);
        const res = await getPublicKpis(
          action.gToken, action.dashOwnerId, action.dashId, action.password,
        );
        if (!res.error) {
          dispatch({
            type: 'loadCards',
            kpis: res.kpis,
            kpisLayout: res.layout,
            dashboardDoc: res.dashDoc,
            collection: 'kpis',
          });
        }
        setLoading(false);
        return res;
      }

      case 'getTemplateKpis': {
        setLoading(true);
        const res = await getTemplateKpis(action.dashId);
        if (!res.error) {
          dispatch({
            type: 'loadCards',
            kpis: res.kpis,
            kpisLayout: res.layout,
            dashboardDoc: res.dashDoc,
            collection: 'kpis',
          });
        }
        setLoading(false);
        return res;
      }

      case 'genAssistantKpis': {
        setLoading(true);
        const result = await genAssistantKpis(
          action.fileId, action.dashboardId, action.kpisList,
        );
        setLoading(false);
        return result;
      }

      case 'getDashResumes': {
        setLoading(true);
        const res = await getDashResumes();
        if (!res.error) {
          dispatch({
            type: 'dashResumes',
            resumes: res,
          });
        } else {
          setLoading(false);
        }
        return res;
      }

      case 'getKpisResumes': {
        setLoading(true);
        const res = await getKpisResumes(action.resumeKey);
        if (!res.error) {
          dispatch({
            type: 'kpisResumes',
            key: action.resumeKey,
            resumes: res,
          });
        } else {
          setLoading(false);
        }
        return res;
      }

      case 'genDashKpisResumes': {
        setLoading(true);
        const res = await genDashKpisResumes();
        if (!res.error) {
          dispatch({
            type: 'genDashResumes',
            key: res,
          });
        } else {
          setLoading(false);
        }
        return res;
      }

      case 'setResumesListener': {
        return setResumesListener(action.resumeKey);
      }

      case 'getKpisFromResume': {
        setLoading(true);
        const res = await getKpisFromResume(action.resumeKey);
        if (!res.error) {
          dispatch({
            type: 'kpisFromResume',
            key: action.resumeKey,
            kpis: res,
          });
        } else {
          setLoading(false);
        }
        return res;
      }

      default:
        return dispatch(action);
    }
  }, [
    ownerId,
    currentDashId,
    getAllInfos,
    getAllInfosLive,
    genPublicKpis,
    cloneCard,
    transferKpis,
    getKpi,
    getKpisLayout,
    saveLayout,
    removeCards,
    getDashboard,
    saveSnapshot,
    editSnapshot,
    removeSnap,
    scheduleSnapshot,
    downloadReportFromCard,
    donwloadImageCard,
    saveKpiCard,
    saveInsightCard,
    getColumnDependecies,
    exportDashboard,
    importDashboard,
    getPlotlyLink,
    //
    genAssistantKpis,
    getDashResumes,
    getKpisResumes,
    genDashKpisResumes,
    setResumesListener,
    getKpisFromResume,
    // comments
    loadComments,
    addComment,
    editComment,
    archiveComment,
    loadMoreComments,
    setDescription,
    // template
    createTemplate,
    editTemplate,
    deleteTemplate,
  ]);

  const kpiAPI = useMemo(() => ({
    loadCardsFromCollection: async (collection) => middleware({ type: 'loadCards', collection }),
    loadLiveCardsFromCollection: async () => middleware({ type: 'loadLiveCards' }),
    saveLayout: async (kpisLayout) => middleware({ type: 'saveLayout', kpisLayout }),
    loadLayout: async () => middleware({ type: 'loadLayout' }),
    // cards
    saveInsightCard: async (kpiLayout, labelKey, LabelData, image) => middleware({
      type: 'saveInsightCard', kpiLayout, labelKey, LabelData, image,
    }),
    saveKpiComment: async (kpiKey, comment) => middleware({ type: 'saveKpiComment', kpiKey, comment }),
    updateKpiShowOnExpand: async (kpiKey, showOnExpand) => middleware({
      type: 'updateKpiShowOnExpand', kpiKey, showOnExpand,
    }),
    saveKpiValueFilters: async (kpiKey, metaGen, pivotTable) => middleware({
      type: 'saveKpiValueFilters', kpiKey, metaGen, pivotTable,
    }),
    saveKpiCard: async (
      kpiName, kpiKey, cardType, dashLayout, metaGen,
      metaGridInfo, pivotTable, styleConfig, ddStyleConfig,
    ) => middleware({
      type: 'saveKpiCard',
      kpiName,
      kpiKey,
      cardType,
      dashLayout,
      metaGen,
      metaGridInfo,
      pivotTable,
      styleConfig,
      ddStyleConfig,
    }),
    removeCards: async (cardsToRemove, allCards, layout) => middleware({
      type: 'removeCards', cardsToRemove, allCards, layout,
    }),
    cloneCard: async (toClone, cardslayout) => middleware({ type: 'cloneCard', toClone, cardslayout }),
    transferKpis: async (
      selectedKpis, targetDashsIds, layout, subsetTableLimit, plan,
    ) => middleware({
      type: 'transferKpis', selectedKpis, targetDashsIds, layout, subsetTableLimit, plan,
    }),
    getKpiInfo: async (kpiId, snap) => middleware({ type: 'getKpiInfo', kpiId, snap }),
    genAssistantKpis: async (fileId, dashboardId, kpisList) => middleware({
      type: 'genAssistantKpis', fileId, dashboardId, kpisList,
    }),
    getDashResumes: async () => middleware({ type: 'getDashResumes' }),
    getKpisResumes: async (resumeKey) => middleware({ type: 'getKpisResumes', resumeKey }),
    genDashKpisResumes: async () => middleware({ type: 'genDashKpisResumes' }),
    setResumesListener: async (resumeKey) => middleware({ type: 'setResumesListener', resumeKey }),
    getKpisFromResume: async (resumeKey) => middleware({ type: 'getKpisFromResume', resumeKey }),
    // snaps
    changeToSnap: async (snapId) => middleware({ type: 'changeToSnap', snapId }),
    saveSnapshot: async (snapName, oldSnaps, cardList, cardsLayout, deleteOlder) => middleware({
      type: 'saveSnapshot', snapName, oldSnaps, cardList, cardsLayout, deleteOlder,
    }),
    editSnapshot: async (editSnap, oldSnaps) => middleware({ type: 'editSnapshot', editSnap, oldSnaps }),
    removeSnapshot: async (toDeleteSnap, oldSnaps) => middleware({ type: 'removeSnapshot', toDeleteSnap, oldSnaps }),
    scheduleSnapshot: async (cronCode, snapName) => middleware({ type: 'scheduleSnapshot', cronCode, snapName }),
    // others
    downloadImgCard: async (cardRef, name) => middleware({ type: 'downloadImgCard', cardRef, name }),
    downloadReportFromCard: async (cardId, reportName, filters) => middleware({
      type: 'downloadReportFromCard', cardId, reportName, filters,
    }),
    getDashInfo: async () => middleware({ type: 'getDashInfo' }),
    setDashInfo: async (dashboardDoc) => middleware({ type: 'setDashInfo', dashboardDoc }),
    setIsLoading: async (l) => middleware({ type: 'setLoading', isLoading: l }),
    loadLayoutAndDash: async () => middleware({ type: 'loadLayoutAndDash' }),
    getColumnDependecies: async (kpiList, globalFilters) => middleware({ type: 'getColumnDependecies', kpiList, globalFilters }),
    exportDashboard: async (dashId, dashName) => middleware({ type: 'exportDashboard', dashId, dashName }),
    importDashboard: async (file, dashName) => middleware({ type: 'importDashboard', file, dashName }),
    getPlotlyLink: async (plotlyId) => middleware({ type: 'getPlotlyLink', plotlyId }),
    // comments
    loadComments: async () => middleware({ type: 'loadComments' }),
    addComment: async (text, mentions) => middleware({ type: 'addComment', text, mentions }),
    editComment: async (text, mentions, commentId) => middleware({
      type: 'editComment', commentId, text, mentions,
    }),
    archiveComment: async (commentId) => middleware({ type: 'archiveComment', commentId }),
    loadMoreComments: async (cursor) => middleware({ type: 'loadMoreComments', cursor }),
    /// description
    setDescription: async (description) => middleware({ type: 'setDescription', description }),
    setCardStyles: async (cardStyles) => middleware({ type: 'setCardStyles', cardStyles }),
    setGlobalFilterSelectors: async (globalFilters, globalLimits) => middleware({
      type: 'setGlobalFilterSelectors', globalFilters, globalLimits,
    }),
    // template
    createTemplate: async (template, kpiItemList, kpisLayout) => middleware({
      type: 'createTemplate', template, kpiItemList, kpisLayout,
    }),
    editTemplate: async (templateId, template) => middleware({
      type: 'editTemplate', templateId, template,
    }),
    deleteTemplate: async (templateId) => middleware({
      type: 'deleteTemplate', templateId,
    }),
    genPublicKpis: async (dashId, operation, pwd, expDt) => middleware({
      type: 'genPublicKpis', dashId, operation, pwd, expDt,
    }),
    getPublicKpis: async (gToken, dashOwnerId, dashId, password) => middleware({
      type: 'getPublicKpis', gToken, dashOwnerId, dashId, password,
    }),
    getTemplateKpis: async (dashId) => middleware({
      type: 'getTemplateKpis', dashId,
    }),
    dashLoaded,
  }), [middleware]);

  return [state, kpiAPI];
}

export default useGridKPI;
